import {store} from "../store/store";
import {productFactory} from "../factory/product.factory";
import uuid from "uuid4";
import {multiPortionFoodsManager} from "./MultiPortionFoodsManager";

export const ProductService = {
    replaceProductByExternalIdInSchema(oldExternalId, newExternalId) {
        store.state.menu.schema.days.map((day) => {
            day.plans.forEach((plan) => {
                plan.foods.forEach((food) => {
                    food.findProductsBy(oldExternalId, 'externalId')
                        .forEach((foodProductToReplace) => {
                            let productReplacement = productFactory.create(
                                uuid(),
                                newExternalId,
                                foodProductToReplace.name,
                                foodProductToReplace.weight,
                                foodProductToReplace.energy.amount,
                                foodProductToReplace.category,
                                foodProductToReplace.allergen,
                                foodProductToReplace.disliked,
                                foodProductToReplace.nutrients,
                                foodProductToReplace.portion,
                            );
                            food.replaceProduct(foodProductToReplace.id, productReplacement);
                            if (food.isMultiPortionFood()) {
                                multiPortionFoodsManager.updateMultiPortionFood(food, store.state.menu.schema);
                            }
                        });
                });
                plan.findProductsBy(oldExternalId, 'externalId')
                    .forEach((planProductToReplace) => {
                        let productReplacement = productFactory.create(
                            uuid(),
                            newExternalId,
                            planProductToReplace.name,
                            planProductToReplace.weight,
                            planProductToReplace.energy.amount,
                            planProductToReplace.category,
                            planProductToReplace.allergen,
                            planProductToReplace.disliked,
                            planProductToReplace.nutrients,
                            planProductToReplace.portion,
                        );
                        plan.replaceProduct(planProductToReplace.id, productReplacement);
                    });
            });
        });
    }
};